<template>
  <div id="app">
    <div class="d-flex d-md-flex flex-column flex-md-row align-items-center fixed-top" v-bind:style="{'padding-top': `${menuPadding}px!important`, 'padding-bottom': `${menuPadding}px!important`, backgroundColor: `rgba(255, 255, 255, ${opacity})`}">
      <h5 class="my-0 mr-md-auto font-weight-normal">
        <router-link to="/site/">
          <img src="./assets/Logo5.png" class="logo" v-bind:style="{width: `${logoWidth}px`}">
        </router-link>
      </h5>

      <nav v-bind:class="'nav text-primary'">
        <router-link v-bind:style="{'padding-top': `${menuItemPadding}px!important`, 'padding-bottom': `${menuItemPadding}px!important`}" class="nav-item" to="/">Home</router-link>
      </nav>

      <nav v-bind:class="'nav text-primary ' + (signUpShown ? 'pt-2' : '')">
        <router-link v-bind:style="{'padding-top': `${menuItemPadding}px`, 'padding-bottom': `${menuItemPadding}px`}" class="nav-item" to="/track/">My Dashboard</router-link>
        <transition name="slide-fade">
          <a v-if="signUpShown" v-on:click="onRequestInviteClicked" class="btn">Early access</a>
        </transition>
      </nav>
    </div>

    <div>
      <router-view v-bind:email="email" v-bind:setRequestInviteModalOpen="setRequestInviteModalOpen" v-bind:onEmailUpdated="onEmailUpdated" />

      <div class="container-fluid">
        <footer class="pt-4 my-md-5 pt-md-5">
          <div class="row">
            <div class="col-12 col-md">
              <img class="mb-2" src="./assets/Logo5.png" alt="" height="36">
              <small class="d-block mb-3 text-muted">© {{(new Date()).getFullYear()}}</small>
            </div>
            <div class="col-6 col-md text-dark">
              <a class="text-success" target="_blank" href="https://www.instagram.com/itchyfeetapp/"><font-awesome-icon class="mr-2" size="3x" :icon="{ prefix: 'fab', iconName: 'instagram' }"/></a>
              <a class="text-success" target="_blank" href="https://www.facebook.com/app.itchyfeet"><font-awesome-icon class="mr-2"  size="3x" :icon="{ prefix: 'fab', iconName: 'facebook-square' }"/></a>
              <a class="text-success" target="_blank" href="https://www.linkedin.com/company/itchyfeet/"><font-awesome-icon size="3x" :icon="{ prefix: 'fab', iconName: 'linkedin' }"/></a>
            </div>
            <div class="col-6 col-md">
              <h5 class="mt-2">Made with <font-awesome-icon class="text-success" icon="heart"/> in Copenhagen & New York City</h5>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <vue-headful
      v-bind:title="requestInviteModalOpen ? 'Itchyfeet - Request Invite' : 'Itchyfeet'"
      description="Itchyfeet is a fun and easy way to seamlessly keep track of your closest friends whereabouts, so you know who is, and who will be in the same city as you"
    />
    <RequestInviteModal v-if="requestInviteModalOpen" v-bind:onCloseClicked="onCloseRequestInviteClicked" v-bind:email="this.email" v-bind:onEmailUpdated="onEmailUpdated" />
  </div>
</template>

<script>
import {TweenLite} from 'gsap/TweenMax'
import RequestInviteModal from './components/Home/RequestInviteModal'

export default {
  name: 'App',
  components: {RequestInviteModal},
  data: function () {
    return {
      scrollPos: 0,
      opacity: 0,
      menuPadding: 6,
      menuItemPadding: 6,
      logoWidth: 250,
      smallNav: false,
      signUpShown: false,
      requestInviteModalOpen: false,
      email: ''
    }
  },
  mounted: function () {
    let self = this
    window.onscroll = function (e) {
      self.scrollPos = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop
    }
  },
  watch: {
    opacity: function (newValue) {
      this.signUpShown = (newValue >= 0.8)
      this.smallNav = (newValue >= 0.2)
    },
    scrollPos: function (newValue) {
      if (newValue > 100) {
        TweenLite.to(this.$data, 1.5, {
          opacity: 0.85,
          logoWidth: 150,
          menuPadding: 1,
          menuItemPadding: (window.innerWidth > 600 ? 12 : (window.innerWidth > 320 ? 8 : 4))
        })
      } else if (newValue === 0) {
        TweenLite.to(this.$data, 1.5, {
          opacity: 0,
          logoWidth: 250,
          menuPadding: (window.innerWidth > 600 ? 10 : (window.innerWidth > 320 ? 8 : 5)),
          menuItemPadding: (window.innerWidth > 600 ? 15 : (window.innerWidth > 320 ? 12 : 8))
        })
      }
    }
  },
  methods: {
    setRequestInviteModalOpen: function (open) {
      if (open) {
        this.requestInviteModalOpen = true
        this.$ua.trackEvent({
          eventCategory: 'Waiting List',
          eventAction: 'Click',
          eventLabel: 'Request Invite Opened',
          eventValue: 'Request Invite Opened'
        })
      } else {
        this.requestInviteModalOpen = false
        this.$ua.trackEvent({
          eventCategory: 'Waiting List', eventAction: 'Click', eventLabel: 'Request Invite Closed', eventValue: 'Request Invite Closed'
        })
      }
    },
    onEmailUpdated: function (email) {
      this.email = email
    },
    onEmailUpdatedEvent: function (e) {
      this.email = e.target.value
    },
    onRequestInviteClicked: function () {
      this.setRequestInviteModalOpen(true)
    },
    onCloseRequestInviteClicked: function () {
      this.setRequestInviteModalOpen(false)
    }
  }
}
</script>

<style lang="scss">
  @import "./styles/app";

  body {
    scroll-behavior: smooth;
  }

  .slide-fade-enter-active {
    transition: all 1s ease;
    animation: bounce-in .5s;
  }
  .slide-fade-leave-active {
    transition: all 1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    animation: bounce-in .5s reverse;
  }

  .bounce-enter-active {
    animation: bounce-in 1s;
  }
  .bounce-leave-active {
    animation: bounce-out .5s reverse;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes bounce-out {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue